import React from 'react'
import SurveyCreationPage from './SurveyCreationPage'

export default function SurveyMyTemplateEditPage() {
  return <SurveyCreationPage editMode />
}